import { render, staticRenderFns } from "./SoftNft.vue?vue&type=template&id=be215036&"
import script from "./SoftNft.vue?vue&type=script&lang=js&"
export * from "./SoftNft.vue?vue&type=script&lang=js&"
import style0 from "./SoftNft.vue?vue&type=style&index=0&id=be215036&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports